import React, { useState } from 'react';
import type { Period } from '../types';
import { D1, FONT, d1, TS } from '../design/tokens';

// "2026-08-10" -> "10/08/2026"
const brDate = (iso?: string) => { if (!iso) return '—'; const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso); return m ? m[3] + '/' + m[2] + '/' + m[1] : iso; };

export interface PeriodosProps {
  periods: Period[];
  onCreatePeriod: (label: string, start: string, end: string) => Promise<void>;
  onActivate: (pid: string) => void;
  onClose: (p: Period) => void;
  onViewReports: (pid: string) => void;
  darkMode: boolean;
}

// Aba de gerenciamento de períodos acadêmicos
export function PeriodosTab({ periods, onCreatePeriod, onActivate, onClose, onViewReports, darkMode:_darkMode }: PeriodosProps) {
  const [npLabel,setNpLabel]=useState(""); const [npStart,setNpStart]=useState(""); const [npEnd,setNpEnd]=useState(""); const [npMsg,setNpMsg]=useState("");
  const handleCreate=async()=>{ if(!npLabel.trim()){setNpMsg("Informe o nome do período (ex: 2026.1)");return;} try{ await onCreatePeriod(npLabel.trim(),npStart,npEnd); setNpMsg("OK: Período "+npLabel+" criado!"); setNpLabel("");setNpStart("");setNpEnd(""); setTimeout(()=>setNpMsg(""),3000); } catch(e:unknown){setNpMsg("Erro: "+(e instanceof Error?e.message:""));} };
  const badge=(txt:string,on:boolean)=>(<span style={{ fontSize:11,fontWeight:600,letterSpacing:0.6,textTransform:"uppercase" as const,padding:"3px 8px",borderRadius:2,color:on?D1.ok:D1.ink2,background:on?D1.okSoft:D1.line2 }}>{txt}</span>);
  const sep=<span style={{ color:D1.line,margin:"0 6px" }}>·</span>;
  return (
    <div style={{ paddingBottom:24 }}>
      <div style={d1.cap}>Calendário acadêmico</div>
      <h1 style={{ ...d1.h1,marginTop:6,marginBottom:20 }}>Períodos letivos</h1>
      <div className="gf-grid-periodos" style={{ display:"grid",gridTemplateColumns:"minmax(0,1.6fr) minmax(0,1fr)",gap:28,alignItems:"start" }}>
        <div style={{ overflowX:"auto" }}>
          <table style={d1.table}>
            <thead><tr>
              <th style={d1.th}>Período</th><th style={d1.th}>Início</th><th style={d1.th}>Término</th><th style={d1.th}>Situação</th><th style={d1.th}></th>
            </tr></thead>
            <tbody>
              {periods.map(p=>(
                <tr key={p.id}>
                  <td style={{ ...d1.td,fontFamily:FONT.serif,fontSize:17,fontWeight:600 }}>{p.label}</td>
                  <td style={{ ...d1.td,fontFamily:FONT.mono,fontSize:12.5 }}>{brDate(p.startDate)}</td>
                  <td style={{ ...d1.td,fontFamily:FONT.mono,fontSize:12.5 }}>{brDate(p.endDate)}</td>
                  <td style={d1.td}>{p.active?badge("Ativo",true):p.closed?badge("Encerrado",false):badge("Inativo",false)}</td>
                  <td style={{ ...d1.td,whiteSpace:"nowrap",textAlign:"right" }}>
                    {!p.active&&!p.closed&&<><button style={{ ...d1.link,fontSize:12.5 }} onClick={()=>onActivate(p.id)}>Ativar</button>{sep}</>}
                    {!p.closed&&<><button style={{ ...d1.link,fontSize:12.5,color:D1.alert }} onClick={()=>onClose(p)}>Encerrar</button>{sep}</>}
                    <button style={{ ...d1.link,fontSize:12.5 }} onClick={()=>onViewReports(p.id)}>{p.closed?"Ver relatório":"Ver"}</button>
                  </td>
                </tr>
              ))}
              {periods.length===0&&<tr><td colSpan={5} style={{ ...d1.td,color:D1.ink3,textAlign:"center" }}>Nenhum período criado ainda.</td></tr>}
            </tbody>
          </table>
        </div>
        <div style={{ ...d1.card,padding:"22px 24px" }}>
          <h2 style={{ ...d1.h2,marginBottom:16 }}>Novo período</h2>
          {npMsg&&<div style={npMsg.startsWith("OK:")?TS.ok:TS.err}>{npMsg}</div>}
          <div style={{ ...d1.cap,marginBottom:6 }}>Identificação</div>
          <input style={{ ...d1.inp,marginBottom:14 }} type="text" placeholder="ex.: 2027.1" value={npLabel} onChange={e=>setNpLabel(e.target.value)} onKeyDown={e=>e.key==="Enter"&&document.getElementById("np-start")?.focus()}/>
          <div style={{ display:"flex",gap:10,marginBottom:20 }}>
            <div style={{ flex:1 }}><div style={{ ...d1.cap,marginBottom:6 }}>Início</div><input id="np-start" style={d1.inp} type="date" value={npStart} onChange={e=>setNpStart(e.target.value)} onKeyDown={e=>e.key==="Enter"&&document.getElementById("np-end")?.focus()}/></div>
            <div style={{ flex:1 }}><div style={{ ...d1.cap,marginBottom:6 }}>Término</div><input id="np-end" style={d1.inp} type="date" value={npEnd} onChange={e=>setNpEnd(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleCreate()}/></div>
          </div>
          <button style={{ ...d1.btn,width:"100%" }} onClick={handleCreate}>Criar período</button>
        </div>
      </div>
    </div>
  );
}
